// extracted by mini-css-extract-plugin
export default {"loginContainer":"Login_loginContainer__bDwwc","loginForm":"Login_loginForm__EZahJ","linkText":"Login_linkText__1Vbyb"};